import { Injectable } from '@angular/core';



    export interface ProfileImage {
        small: string;
        medium: string;
        large: string;
    }

    export interface Links {
        self: string;
        html: string;
        photos: string;
        likes: string;
        portfolio: string;
        following: string;
        followers: string;
    }

    export interface User {
        id: string;
        updated_at: Date;
        username: string;
        name: string;
        first_name: string;
        last_name: string;
        portfolio_url: string;
        bio: string;
        location: string;
        total_likes: number;
        total_photos: number;
        total_collections: number;
        profile_image: ProfileImage;
        links: Links;
    }

    export interface Urls {
        raw: string;
        full: string;
        regular: string;
        small: string;
        thumb: string;
    }

    export interface Links2 {
        self: string;
        photos: string;
    }

    export interface Category {
        id: number;
        title: string;
        photo_count: number;
        links: Links2;
    }

    export interface Links3 {
        self: string;
        html: string;
        download: string;
        download_location: string;
    }

    export class Result {
        id: string;
        created_at: Date;
        updated_at: Date;
        width: number;
        height: number;
        color: string;
        likes: number;
        liked_by_user: boolean;
        user: User;
        current_user_collections: any[];
        urls: Urls;
        categories: Category[];
        links: Links3;
    }

    export class UnsplashResponse {
        total: number;
        total_pages: number;
        results: Result[];
    }




    export interface ProfileImage {
        small: string;
        medium: string;
        large: string;
    }

    export interface Links {
        self: string;
        html: string;
        photos: string;
        likes: string;
        portfolio: string;
        following: string;
        followers: string;
    }

    export interface User {
        id: string;
        updated_at: Date;
        username: string;
        name: string;
        first_name: string;
        last_name: string;
        twitter_username: string;
        portfolio_url: string;
        bio: string;
        location: string;
        total_likes: number;
        total_photos: number;
        total_collections: number;
        profile_image: ProfileImage;
        links: Links;
    }

    export interface Urls {
        raw: string;
        full: string;
        regular: string;
        small: string;
        thumb: string;
    }

    export interface Links2 {
        self: string;
        photos: string;
    }

    export interface Category {
        id: number;
        title: string;
        photo_count: number;
        links: Links2;
    }

    export interface Links3 {
        self: string;
        html: string;
        download: string;
        download_location: string;
    }








// WEBPACK FOOTER //
// ./src/app/unsplash/unsplash.response.ts